import { useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const BubbleEffect = ({ x, y, onComplete }) => {
  const bubbles = Array.from({ length: 12 }, (_, i) => ({
    id: i,
    size: Math.random() * 20 + 10,
    angle: (i * 30) + Math.random() * 15,
    distance: Math.random() * 80 + 40,
    duration: Math.random() * 0.4 + 0.5,
    delay: Math.random() * 0.1,
    color: i % 2 === 0 ? 'sky' : 'pink'
  }));

  return (
    <div 
      className="fixed pointer-events-none z-[60]" 
      style={{ left: x, top: y }}
    >
      {bubbles.map((bubble) => {
        const radian = (bubble.angle * Math.PI) / 180;
        const targetX = Math.cos(radian) * bubble.distance;
        const targetY = Math.sin(radian) * bubble.distance;
        
        return (
          <motion.div
            key={bubble.id}
            className={`absolute rounded-full ${
              bubble.color === 'sky' 
                ? 'bg-gradient-to-br from-sky-300 to-sky-500' 
                : 'bg-gradient-to-br from-pink-300 to-pink-500'
            }`}
            style={{
              width: bubble.size,
              height: bubble.size,
              marginLeft: -bubble.size / 2,
              marginTop: -bubble.size / 2,
            }}
            initial={{ 
              scale: 0, 
              x: 0, 
              y: 0, 
              opacity: 0.9 
            }}
            animate={{ 
              scale: [0, 1.2, 0.8],
              x: targetX,
              y: targetY,
              opacity: [0.9, 0.7, 0]
            }}
            transition={{
              duration: bubble.duration,
              delay: bubble.delay,
              ease: 'easeOut'
            }}
            onAnimationComplete={bubble.id === 0 ? onComplete : undefined}
          />
        );
      })}
    </div>
  );
};

export const useBubbleEffect = () => {
  const [bubbleEffects, setBubbleEffects] = useState([]);

  const triggerBubbles = useCallback((e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;
    
    const id = Date.now();
    setBubbleEffects(prev => [...prev, { id, x, y }]);
    
    // Remove after animation
    setTimeout(() => {
      setBubbleEffects(prev => prev.filter(effect => effect.id !== id));
    }, 1000);
  }, []);

  const BubbleEffects = () => (
    <AnimatePresence>
      {bubbleEffects.map(effect => (
        <BubbleEffect 
          key={effect.id} 
          x={effect.x} 
          y={effect.y}
          onComplete={() => {}}
        />
      ))}
    </AnimatePresence>
  );

  return { triggerBubbles, BubbleEffects };
};

export default useBubbleEffect;
